import useAppTheme from '../design_system/hooks/useAppTheme';
import Globe from '../design_system/icon/Globe';
import Link from '../design_system/Link/Link';
import {ContentColor} from '../design_system/theme/useContentPalette';
import Typography, {Size} from '../design_system/typography/Typography';
import {EventMapAddress_VenueFragment} from '../event/__generated__/Event.graphql';
import Flex from '../layout/flex/Flex';

import {css} from '@emotion/react';
import React from 'react';
import {useTranslation} from 'react-i18next';

export interface MapAddressData {
  readonly name: string;
  readonly station: string;
  readonly url: string;
}

export interface Props {
  readonly address: Maybe<EventMapAddress_VenueFragment>;
}

export default function MapAddress(props: Props): JSX.Element {
  const {address} = props;
  const {t} = useTranslation();
  const {spacing} = useAppTheme();

  if (address == null) {
    return (
      <Flex>
        <Globe
          color={ContentColor.PRIMARY}
          size={20}
        />
        <Typography
          color={ContentColor.PRIMARY}
          css={css({marginLeft: spacing.x8})}
          size={Size.M}
        >
          {t('components.event-card.online-venue')}
        </Typography>
      </Flex>
    );
  }

  let addressName = (
    <Typography
      variant="span"
      weight={700}
    >
      {address.name}
    </Typography>
  );
  if (address.mapURL != null) {
    addressName = <Link to={address.mapURL}>{addressName}</Link>;
  }

  return (
    <Flex
      sx={css({
        alignItems: 'center',
        gap: spacing.x16,
      })}
    >
      <img
        alt={t('pages.event.map-icon')}
        css={css({
          borderRadius: '11px',
        })}
        src="/static/images/map-icon.jpg"
        width="80px"
      />

      <div>
        <Typography variant="div">{address.station}</Typography>

        {addressName}
      </div>
    </Flex>
  );
}
